import React from 'react';
import { List, Spin } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { addItem } from 'app/store/reducers/cart.reducer';
import { setUiChangeRewardConfirmModal } from 'app/store/reducers/ui.reducer';
import { BitecoinRewardCategoriesListItem } from 'entities/Bitecoin/components/BitecoinRewardCategoriesListItem';
import { EmptyRewardListPlaceholder } from 'entities/Bitecoin/components/EmptyRewardListPlaceholder';
import { IBitecoinRewardModel } from 'entities/Bitecoin/Bitecoin.models';
import { ChangeRewardConfirmModal } from 'entities/Bitecoin/components/ChangeRewardConfirmModal';

export const BitecoinRewardList: React.FC = () => {
  const dispatch = useAppDispatch();
  const { bitecoinGroupedRewardCollection, bitecoinRewardCollectionLoading, bitecoinCustomerInfoModel } = useAppSelector(
    (state) => state.bitecoin,
  );
  const { cartModel, cartModelLoading } = useAppSelector((state) => state.cart);
  const hasReward = cartModel?.items.some((item) => item.rewardId);

  const onRewardItemClick = (reward: IBitecoinRewardModel) => {
    if (cartModel?.promo || hasReward) {
      dispatch(setUiChangeRewardConfirmModal({ isVisible: true, rewardItem: reward }));
    } else {
      addRewardToCart(reward);
    }
  };

  const addRewardToCart = (reward: IBitecoinRewardModel) => {
    const { id, menuItem, priceInBitecoins } = reward;

    dispatch(
      addItem({
        menuItemId: menuItem.id,
        addOns: [],
        mealBuilderPicks: [],
        quantity: 1,
        price: priceInBitecoins,
        rewardId: id,
      }),
    );
  };

  return (
    <>
      <ChangeRewardConfirmModal onContinue={addRewardToCart} />
      <Spin spinning={bitecoinRewardCollectionLoading}>
        <List
          dataSource={bitecoinGroupedRewardCollection || undefined}
          renderItem={(item) => (
            <BitecoinRewardCategoriesListItem
              item={item}
              bitecoinBalance={bitecoinCustomerInfoModel?.bitecoins || 0}
              onRewardItemClick={onRewardItemClick}
              isDisabled={cartModelLoading}
            />
          )}
          locale={{ emptyText: <EmptyRewardListPlaceholder /> }}
          className="pb-7"
        />
      </Spin>
    </>
  );
};
